function dec2hex(dec: number) {
  return dec.toString(16).padStart(2, '0')
}

export default (length?: number) => {
  const arr = new Uint8Array((length || 40) / 2)
  window.crypto.getRandomValues(arr)
  return Array.from(arr, dec2hex).join('')
}
